import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import {environment} from '../environments/environment';

@Injectable()
export class AppConfig {
  public baseUrl: string = environment.apiBaseUrl;
  public jsonHeaders: {};
  public jsonTokenHeaders: {};
  public formDataHeaders: {};

  public authToken = new BehaviorSubject(null);
  public token;

  constructor() {
    this.authToken.subscribe(res => {
      this.token = res;

      this.jsonTokenHeaders = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json' ,
          'Authorization': 'Bearer ' + this.token
        })
      };

      this.formDataHeaders = {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + this.token
        })
      };
    });
    this.jsonHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' ,
        'Authorization': 'my-auth-token'
      })
    };
  }
  setAuthToken(token){
    this.authToken.next(token);
  }
}
